import './RichText.css';
import React, { useState } from 'react';
import { parse } from 'node-html-parser';
import { RichText as SitecoreRichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { canUseDOM, get } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { tealiumCheckRightTextClick, tealiumMergeClickData } from '../../utils/tealium';
import { renderRTListSchema, getListsTexts } from '../../utils/seo';
// import fadeImg from '../../resources/img/transparent.png';

import { convertToAnalyticObject } from '../../utils/analytics';
export const scrollLazyLoad = () => {
  let images = document.getElementsByClassName('img-lazy-load');
  if (images && images.length) {
    let bottomPos = document.documentElement.scrollTop + window.innerHeight;
    for (const img of images) {
      if (img.getBoundingClientRect().y) {
        console.info('lazy working');
        if (img.getBoundingClientRect().y < bottomPos) {
          img.classList.remove('img-lazy-load');
          img.setAttribute('src', img.getAttribute('data-src'));
        }
      } else {
        console.info('lazy not working');
        img.classList.remove('img-lazy-load');
        img.setAttribute('src', img.getAttribute('data-src'));
      }
    }
  }
};
export const checkIE = () => {
  if (canUseDOM) {
    let ua = window.navigator.userAgent,
      msie = ua.indexOf("MSIE");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      return true;
    }
  }
  return false;
};
export const parsedHtml = (copy, isIE) => {
  var elem = document.createElement('div');
  elem.innerHTML = copy;
  var images = elem.getElementsByTagName('img');
  let paramsToAdd = '?&cx=0.5&cy=0.5&cw=1200';
  for (var i = 0; i < images.length; i++) {
    if (images[i].width && images[i].width > 1200) {
      let imgSrc = images[i].src;
      imgSrc = imgSrc + paramsToAdd;
      images[i].src = imgSrc;
    }
    if (!isIE) {
      images[i].classList.add('img-lazy-load');
      images[i].setAttribute('data-src', images[i].src);
      images[i].setAttribute('src', '');
    }
  }
  return {
    images: images.length,
    output: elem.innerHTML
  };
};
const RichText = _ref => {
  let {
    fields,
    params
  } = _ref;
  const secondColumn = params !== undefined && params['Position'] === 'Second Column' ? true : false;
  const center = params !== undefined && params['Position'] === 'Center Align' ? true : false;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [output, setOutput] = useState('');
  const richtextRef = React.useRef();
  const readMoreLabel = get(fields, 'richTextSettings.fields.readMoreLabel.value');
  const isExpandable = get(fields, 'isExpandable.value');
  const textValue = get(fields, 'text.value', '');
  const [textHidden, setTextHidden] = useState(isExpandable);
  const [componentListsSchema, setComponentListsSchema] = React.useState([]);

  // #20991
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }

  // #20991
  React.useEffect(() => {
    if (fields && fields.text) {
      const isIE = checkIE();
      if (canUseDOM) {
        const obj = parsedHtml(fields && fields.text && fields.text.value, isIE);
        setOutput(obj.output);
        if (obj.images && !isIE) {
          setTimeout(() => {
            scrollLazyLoad();
            window.addEventListener('scroll', scrollLazyLoad);
          }, 1);
        }
      }
    }
    if (richtextRef.current) {
      richtextRef.current.classList.remove('height-fix');
    }
  }, [textValue]);
  React.useEffect(() => {
    const dom = parse(textValue);
    const rtLists = getListsTexts(dom);
    if (rtLists.length) setComponentListsSchema(rtLists);
  }, []);
  if (!fields || !fields.text) {
    console.info('RichText component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [RichText component is empty: please provide data source]");
    }
    return null;
  }
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: `row m09-rich-text`,
    style: output ? center ? {
      textAlign: 'center'
    } : {} : {
      display: 'none'
    }
  }, secondColumn && /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: center ? 'col-md-12' : 'col-md-10'
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    className: "rich-text ",
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: textHidden ? 'rich-text--hidden' : ''
  }, pageEditing ? /*#__PURE__*/React.createElement(SitecoreRichText, {
    tag: "div",
    className: "rich-text__inner",
    field: fields && fields.text
  }) : /*#__PURE__*/React.createElement("div", {
    ref: richtextRef,
    className: "rich-text__inner height-fix",
    dangerouslySetInnerHTML: {
      __html: output
    },
    onClick: e => tealiumCheckRightTextClick(e, tealiumMergeClickData(eventsAnalytics['richTextAnalytics'], params))
  })), textHidden && /*#__PURE__*/React.createElement("div", {
    className: "rich-text__show-bar"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: () => {
      setTextHidden(false);
    }
  }, readMoreLabel)))), secondColumn && /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  })), componentListsSchema.map(listSchema => renderRTListSchema(listSchema)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    className
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`,
    "data-cy": "rich-text"
  }, children);
};
export const commonStyles = "c1j121nz";
export const ltrStyles = "l13zlhnl";
export const rtlStyles = "r1lnyela";
export default RichText;